import { getGroupListApi } from '../api/groups';
import types from '../types';

export const getGroupList = (filters, jwt) => async (dispatch) => {
  try {
    dispatch({ type: types.reducerTypes.GROUP_LIST_PENDING });
    const data = await getGroupListApi(filters, jwt);
    dispatch({
      type: types.reducerTypes.GROUP_LIST_SUCCESS,
      // Tolerate either { results: [...] } or a bare array.
      payload: { results: data?.results ?? data ?? [] },
    });
  } catch (e) {
    console.log(e);
    dispatch({ type: types.reducerTypes.GROUP_LIST_ERROR, payload: 'Unexpected Error!' });
  }
};
